module.exports = __webpack_public_path__ + "f813009845f07251e7c99d562c0c628a.png";